import { Helmet } from "react-helmet"
import Heading from '../../Front/showcase_2.o/ui/Heading'
import { Col, Container, Image, Row } from "react-bootstrap"
import ShopLabdiamond from "../../Front/ShopLabdiamond"
import ShopLabring from "../../Front/showcase_2.o/Components/Shoplabring"
// import { Link } from "@material-ui/core"
import Labg from "../../../Assets/images/swales-img/labg.jpg"
import Appointmentimg from "../../../Assets/images/swales-img/appointmentlab.jpg"
import { Link } from "react-router-dom/cjs/react-router-dom.min" 
import { useSelector } from "react-redux"
import { helmet_url } from "../../../Helpers/request"



const LabGrowDiamondEnagementRing = () => {
const metaData=useSelector(data=>data?.persistedReducer?.meta?.meta)
    return (
        <div className="labdiamondengsec">
    
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaData.title}</title>
                <meta name="description" content={metaData.description}></meta>
                <meta name="keywords" content={metaData.keywords}></meta>
                <link rel="canonical" href={`${helmet_url}/${metaData?.web_url}`} /> 
            </Helmet>
            <section className='perfect-diamond gemstone-glamour section-space'> 
        <Container>
             <Row>
                <Col md={6}>  
                    <Heading className='pb-2 text-center'>
                        <span>Create Your Perfect <br/> Lab-Grown Diamond Engagement Ring</span>
                        {/* <p>Create Your Perfect <br/> Lab-Grown Diamond Engagement Ring</p> */}
                    </Heading> 
                    <div className='text-center pt-3'>
                        <Link to='/diamonds/lab-grown-diamonds' className="sd_btn_outline" style={{color:"#fff", borderColor:"#607980"}}>Start With A Lab Diamond</Link>
                        <Link to='/engagement-rings' className="sd_btn_outline" style={{color:"#fff", borderColor:"#607980"}}>Start With A Ring setting</Link>
                    </div>
                </Col> 
             </Row>
        </Container>
    </section>

            <div className="stlewrapper">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className="text-center">
                                <h1>Lab Grown Engagement Rings</h1>
                                <p>Express your love with the brilliance of <b>lab grown engagement rings</b> in the UK offered by <b>Swales Diamonds</b>. Lab diamonds are produced under controlled environments, demanding excellent quality and brilliance. Our lab diamonds are chemically identical to natural diamonds but cost much less, allowing couples to invest in bigger, high-quality stones. With increasing awareness of ethical sourcing, lab-created diamonds are trending among new-age couples. We offer a massive range of stunning lab diamond jewellery in the UK, which makes finding the perfect engagement ring all the more straightforward.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ShopLabdiamond />
            <ShopLabring />
            <div className="text-center pb-5 bookappointment">
                <Link className='sd_btn_outline' to="/make-an-appointment">Book An Appointment</Link>
            </div>
            <section className='custom-design section-space redefining-wrap'>
            <Container className="showcase-container">
                <Row className='align-items-center'>
                    <Col md={7} xs={12}>
                        <Heading className="text-start"> 
                            <h2 className='text-uppercase'>Redefining Brilliance with Lab-Grown Diamonds</h2>
                            <p className='mb-3'>We understand that every love story is unique, and each couple deserves an exceptional engagement ring that represents it. Through our <Link to='/custom-design' className="cer-btn"><b>custom engagement rings</b></Link>, we showcase designs that tell the story of your journey and support an eco-friendly choice. By setting your custom ring with a lab-grown diamond, we promise it is every bit as stunning as it is ethical. Our lab-grown diamonds have all the sparkle of a mined diamond, with none of the environmental burden: celebrating love for a brighter and greener tomorrow. </p>
                            <p className='mb-3'>Our <b>lab-created diamond engagement rings</b> represent a remarkable balance between keeping up with modern trends and staying true to quality. We use advanced technologies that create diamonds identical to naturals in brilliance and durability. Moreover, our diamonds are ethically sourced, affordable, and conflict-free. The combination of all these features makes lab-created diamonds a responsible and stunning alternative for today's couple. Your ring will be equally spectacular and purposeful when you include lab-grown diamonds in any collection or opt for a custom design.</p>
                            <div className='bookappointment sd_about_btn_left mt-5'> 
                                <Link to='/diamonds/lab-grown-diamonds' className="sd_btn_outline">Shop Lab Grown Diamonds</Link>
                            </div> 
                        </Heading>
                    </Col>
                    <Col md={5} xs={12} className='text-center'>
                        <Image src={Labg} alt='Lab Grown Diamonds' className='img-fluid' />  
                    </Col>
                </Row>
            </Container>
        </section>
        <div className="stlewrapper">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className="text-center">
                                <h3>How long does it take to produce a lab-grown diamond?</h3>
                                <p>Considering its colour and carat weight, a lab-grown diamond can take about one month to form. Impressive quality colour and larger sizes require an equivalently longer period for growth. On the other hand, natural diamonds have been formed deep inside the Earth's crust for millions of years. In a way, though the lab-grown diamond-making process may take longer for superior characteristics, it is much faster and more sustainable than waiting for nature to do the work over millions of years!
                                </p>
                                <div className='bookappointment sd_about_btn_center mt-5'> 
                                <Link to='/diamonds/lab-grown-diamonds' className="sd_btn_outline">Search Lab Grown Diamonds</Link>
                            </div>  
                            </div> 
                        </Col>
                    </Row>
                </Container> 
            </div>
            <section className='custom-design section-space meetwithuswrap'>
            <Container className="showcase-container">
                <Row className='align-items-center'>
                <Col md={{offset: 1, span: 7}} xs={12} className='text-center '>
                        <Image src={Appointmentimg} alt='Meet With Us' className='img-fluid' />  
                    </Col>
                    <Col md={4} xs={12}>
                        <Heading className="text-start meetwithus"> 
                            <h2 className='text-uppercase'>Meet With Us</h2>
                            <p className='mb-3'>Explore Your Perfect Diamond, <br/>Handpicked For You</p>
                            <div className='bookappointment sd_about_btn_left mt-5'> 
                                <Link to='/make-an-appointment' className="sd_btn_outline">Book Now</Link> 
                            </div> 
                        </Heading>
                    </Col>
                  
                </Row>
            </Container>
        </section>
        <div className="stlewrapper">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className="text-center">
                                <h3>Where to buy lab grown diamonds?</h3>
                                <p>Opting for a credible jeweller when buying diamonds grown in a lab for perfect craftsmanship and good services is recommended. At Swales, we sell only top-quality sourced diamonds and expert guidance. Custom-made or pre-set, we ensure that each diamond in our collection radiates brilliance, beauty, and lasting value. Visit Swales for a diamond meant to be as unique as you.
                                </p>
                                <div className='bookappointment sd_about_btn_center mt-5'> 
                                <Link to='/diamonds/lab-grown-diamonds' className="sd_btn_outline">Browse Our Collection</Link>
                            </div>   
                            </div> 
                        </Col> 
                    </Row>
                </Container> 
            </div>

        </div>
    )
}

export default LabGrowDiamondEnagementRing